// Función para obtener el tema actual
function getCurrentTheme() {
  return localStorage.getItem("color-theme");
}

// Función para aplicar el tema
function applyTheme(theme) {
  const html = document.documentElement;
  
  if (theme === "dark") {
    html.classList.add("dark");
    localStorage.setItem("color-theme", "dark");
  } else {
    html.classList.remove("dark");
    localStorage.setItem("color-theme", "light");
  }
}

// Función para actualizar los iconos
function updateIcons(theme) {
  const themeToggleDarkIcon = document.getElementById("theme-toggle-dark-icon");
  const themeToggleLightIcon = document.getElementById("theme-toggle-light-icon");
  
  if (theme === "dark") {
    themeToggleDarkIcon.classList.add("hidden");
    themeToggleLightIcon.classList.remove("hidden");
  } else {
    themeToggleDarkIcon.classList.remove("hidden");
    themeToggleLightIcon.classList.add("hidden");
  }
}

// Inicialización del tema al cargar la página
function initializeTheme() {
  const savedTheme = getCurrentTheme();
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  
  let theme;
  
  if (savedTheme) {
    theme = savedTheme;
  } else {
    theme = prefersDark ? "dark" : "light";
  }
  
  applyTheme(theme);
  updateIcons(theme);
}

// Función para cambiar el tema
function toggleTheme() {
  const currentTheme = getCurrentTheme();
  const newTheme = currentTheme === "dark" ? "light" : "dark";
  
  applyTheme(newTheme);
  updateIcons(newTheme);
  
  // Dispatch event para otros componentes que puedan necesitarlo
  document.dispatchEvent(new Event("dark-mode"));
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeTheme);
} else {
  initializeTheme();
}

// Agregar event listener al botón de cambio de tema
const themeToggleBtn = document.getElementById("theme-toggle");
if (themeToggleBtn) {
  themeToggleBtn.addEventListener("click", toggleTheme);
}
